import {  createSlice } from '@reduxjs/toolkit';

const initialState = {
    loginData: [],
    isLoggedIn: false,
    user: ""
}
const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
      clearLoginData : (state) => {
        state.loginData = [];
        state.isLoggedIn = false;
        // state.user = null;

        // sessionStorage.clear();
        // localStorage.clear();
        // indexedDB.deleteDatabase("combinedDB");
        // indexedDB.deleteDatabase("SmartDevicesDataDB");
        
        // localStorage.removeItem("user");
      },
      addLoginResponse: (state, action) => {
         state.loginData = action.payload;
         state.isLoggedIn = true;
         //state.user = action.payload;
         //localStorage.setItem("user", JSON.stringify(action.payload));
      }
    }
});

export const { clearLoginData, addLoginResponse } =  loginSlice.actions;
export default loginSlice.reducer;